




import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class Redirect extends Vue {
  $login: any

  mounted () {
    if (this.$login.is()) {
      return this.$router.replace('/dashboard')
    }
    this.$router.replace({name: 'login'})
  }
}
